/**
 * 背景切り替えアニメーション
 *
 * data-bg-change-anim を付与した要素が指定範囲に入っている間、
 * 背景デザイン切り替え用のクラスを付け外しする。
 */
document.addEventListener("DOMContentLoaded", function () {
  var targets = document.querySelectorAll("[data-bg-change-anim]");
  var activeClass = "-is-bg-change-active";

  if (!targets.length) return;

  if (
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);

  targets.forEach(function (target) {
    window.ScrollTrigger.create({
      trigger: target,
      start: target.dataset.bgChangeStart || "top 70%",
      end: target.dataset.bgChangeEnd || "bottom 30%",
      toggleClass: {
        targets: target,
        className: activeClass,
      },
    });
  });
});
